/**
 * Per-task model settings types and ordering.
 */

export type TaskCategory = {
  id: string;
  title: string;
  description: string;
};

export const TASK_CATEGORIES: TaskCategory[] = [
  {
    id: "curriculum",
    title: "Course & Curriculum Design",
    description: "Macro-level curriculum generation, syllabus outlines, and core canonical lesson authoring.",
  },
  {
    id: "personalization",
    title: "Learner Personalization & Remediation",
    description: "Adaptive content tailored on-the-fly to each learner's background and quiz performance.",
  },
  {
    id: "assessments",
    title: "Assessments & Diagnostics",
    description: "Lesson-level knowledge checks and domain-wide adaptive diagnostic benchmark quizzes.",
  },
  {
    id: "translation",
    title: "Multilingual Translation & Localization",
    description: "High-fidelity translation into Arabic and secondary languages preserving technical schemas.",
  },
];

export const TASK_ORDER = [
  "course_outline_generation",
  "canonical_lesson",
  "personalized_scenario",
  "personalized_scenario_translated",
  "remedial_lesson",
  "generate_quiz",
  "generate_placement_quiz",
  "translate_lesson",
  "translate_quiz",
  "translate_placement_quiz",
] as const;

export type TaskSetting = {
  task: string;
  label: string;
  description: string | null;
  model: string;
  isReasoning: boolean;
  reasoningEffort: string | null;
  maxOutputTokens: number;
  category?: string;
  updatedAt: string | null;
  updatedBy: string | null;
};
